export const locale = {
  lang: 'en',
  data: {
    TABLE: {
      ID: 'Id',
      SELLER_BUSINESS_NAME: 'Seller',
      DEBTOR_BUSINESS_NAME: 'Debtor',
      INVOICE_NUMBER: 'Invoice number',
      INVOICE_AMOUNT: 'Invoice amount',
    },
    ERROR: {
      REQUIRED: 'Value required',
      HIGH: 'Interest too high',
      WRONG_TRANSACTION_PASSWORD: 'Wrong transaction password',
    },
    MASSIVE_BID: {
      TITLE: 'Massive purchase',
      FUND: 'Fund',
      VIRTUAL_BALANCE: 'Available balance',
      TOTAL_DOWN_PAYMENT: 'Total down payments',
      ALERT_INSUFFICIENT_LIQUIDITY: 'Attention! The account balance is not sufficient to pay the down payments of all the selected auctions. Contact the CashMe team for further information or make a transfer to ensure sufficient liquidity.',
      MASTER_RATE: 'Bid interest rate',
      APPLY_TO_ALL: 'Apply to all',
      MASTER_RATE_HINT: 'The rate can be changed auction by auction in the table below.',
      DOWN_PAYMENT: 'Down payment',
      MAX_RATE: 'Current rate',
      BID_RATE: 'Your bid',
      DOWNLOAD_CONDITIONS: 'Download the transfer conditions',
      IAS_COMPLIANT_INVOICE: 'IAS Compliant transfer: the rate cannot be changed',
      TRANSACTION_PASSWORD: 'Transaction password',
      TOS_1: 'Confermo di conoscere e accetto i ',
      TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
      TOS_2: 'Confermo di conoscere e accetto le "Condizioni della Cessione" di ciascuna asta selezionata, che ho scaricato e verificato.',
      TOS_3:
        'Accetto che il pagamento del Credito da parte del Debitore Ceduto verrà effettuato sul conto corrente bancario intestato ' +
        'all\'Istituto di Pagamento, il quale provvederà prontamente a trasferire il relativo incasso sul Conto di Pagamento del Cessionario, ' +
        'al netto del Saldo dovuto al Cedente.',
      TOS_4:
        'Accetto che CashMe, a seguito dell\'incasso di ciascun Credito da parte del l\'Istituto di Pagamento, provveda a calcolare ' +
        'l\'importo del Saldo e che l\'Istituto di pagamento stesso provveda ad utilizzare parte dell\'incasso per procedere al pagamento ' +
        'del Saldo dovuto direttamente a favore del Cedente ad eccezione delle cessioni IAS Compliant.',
      SEND: 'Send {{count}} bids',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      RESULT_SUMMARY: '{{success}} bids sent out of {{total}}',
      OUTCOME: 'Outcome',
      OUTCOME_SUCCESS: 'Bid sent',
      ERROR: {
        GENERAL: 'Error: bids not sent. Please retry.',
        BETTER_OFFER_EXISTS: 'A better offer already exists',
        RATE_ABOVE_MAX: 'Interest rate above the allowed maximum',
        SAME_BUYER: 'Cannot raise on your own offer',
        AUCTION_SOLD: 'Auction already awarded',
        AUCTION_NOT_ACTIVE: 'Auction not started yet or already expired',
        ZERO_BID: 'Zero value bid',
        RATE_BELOW_MIN: 'Interest rate below the allowed minimum',
        MAX_BID_INVALID: 'Invalid max bid',
        WRONG_BUYER: 'Auction not available for this buyer',
        WRONG_FUND: 'Invalid fund',
      },
    },
  },
};
